module.exports = __webpack_public_path__ + "img/weChat.0494f6fd.jpg";